<template>
  <div class="onlineNs">
    <!-- <Top :title="name" :message="tips" v-if="tips != ''" /> -->
    <van-form @submit="onSave" label-width="60" ref="onlineNsForm" validate-first>
      <div class="main">
        <van-cell-group>
          <van-panel title="车辆信息" icon="logistics">
            <van-field
              v-model="carInfoDesc"
              clickable
              readonly
              name="carNo"
              label="车辆"
              ref="carNo"
              placeholder="请选择车辆"
              required
              @click="showCarPicker = true"
              :rules="[{ required: true, message: '请选择车辆' }]"
            >
              <!-- <template #button>
                <van-button size="small" icon="scan" style="bottom: auto;width: auto;right: 8px;" @click=""></van-button>
              </template> -->
            </van-field>
            <van-popup v-model="showCarPicker" position="bottom" round :safe-area-inset-bottom="true">
              <van-picker
                title="选择车辆"
                show-toolbar
                :columns="carList"
                @confirm="onConfirmCar"
                @cancel="showCarPicker = false"
                :default-index="0"
              >
                <template #option="car">
                  <span>{{ car.carNo }}【
                    <span v-if="car.carType == '01'">大型汽车</span>
                    <span v-if="car.carType == '02'">小型汽车</span>
                    <span v-if="car.carType == '51'">新能源-大型汽车</span>
                    <span v-if="car.carType == '52'">新能源-小型汽车</span>】
                  </span>
                </template>
              </van-picker>
            </van-popup>
          </van-panel>
          <van-panel title="预约检测站" icon="shop-o">
            <van-field
              clickable
              readonly
              name="detection"
              label="检测站"
              placeholder="请选择检测站"
              v-model="detectionDesc"
              ref="detection"
              @click="showDetectionPicker = true"
              required
              :rules="[{ required: true, message: '请选择检测站' }]"
            />
            <van-popup v-model="showDetectionPicker" position="bottom" round :safe-area-inset-bottom="true">
              <van-picker
                title="选择检测站"
                show-toolbar
                :columns="detectionList"
                @confirm="onConfirmDetection"
                @cancel="showDetectionPicker = false"
                :default-index="0"
                style="text-align: center;"
              >
                <template #option="detection">
                  <span>{{ detection.name }}（{{ detection.nearby }}km）</span>
                </template>
              </van-picker>
            </van-popup>
            <van-field
              clickable
              readonly
              name="setMeal"
              label="年检套餐"
              placeholder="请选择年检套餐"
              v-model="setMealDesc"
              ref="setMeal"
              @click="setMealPickerClick"
              required
              :rules="[{ required: true, message: '请选择年检套餐' }]"
            />
            <van-popup v-model="showSetMealPicker" position="bottom" round :safe-area-inset-bottom="true">
              <van-picker
                title="选择年检套餐"
                show-toolbar
                :columns="setMealList"
                @confirm="onConfirmsetMeal"
                @cancel="showsetMealPicker = false"
                :default-index="0"
              >
                <template #option="option">
                  <span>{{ option.desc }}（{{ option.price }}元）</span>
                </template>
              </van-picker>
            </van-popup>
          </van-panel>
          <van-panel title="个人信息" icon="user-o">
            <van-field
              v-model="mobile"
              name="mobile"
              label="手机号"
              placeholder="预约年检手机号"
              ref="mobile"
              type="tel"
              clearable
              required
              :rules="[{ validator: validatorMobile, message: '请输入正确的手机号' }]"
            >
            </van-field>
            <van-field
              v-model="userRealName"
              name="userRealName"
              label="姓名"
              placeholder="请输入姓名"
              ref="userRealName"
              clearable
            />
            <van-field
              readonly
              clickable
              name="nsDate"
              :value="nsDate"
              label="年检时间"
              placeholder="点击选择日期"
              @click="showDatePicker = true"
              ref="nsDate"
              clearable
            />
            <van-popup v-model="showDatePicker" position="bottom" round :safe-area-inset-bottom="true">
              <van-datetime-picker
                type="date"
                title="选择年月日"
                @confirm="onConfirmDate"
                @cancel="showDatePicker = false"
                :min-date="new Date(new Date().valueOf() + 24 * 60 * 60 * 1000)"
              />
            </van-popup>
          </van-panel>
          <van-panel title="接车信息" icon="vip-card-o" v-if="pickShow">
            <van-field
              readonly
              clickable
              name="area"
              :value="area"
              label="选择地区"
              placeholder="地区信息"
              @click="showArea = true"
              ref="area"
              is-link
            />
            <van-popup v-model="showArea" position="bottom" :safe-area-inset-bottom="true">
              <van-area :area-list="areaList" @confirm="onConfirmArea" @cancel="showArea = false" />
            </van-popup>
            <van-field
              v-model="detail"
              rows="1"
              autosize
              label="详细地址"
              type="textarea"
              placeholder="街道门牌信息"
              ref="detail"
              @blur="detailBlur"
            />
            <van-field
              readonly
              clickable
              name="pickDate"
              :value="pickDate"
              label="接车时间"
              placeholder="点击选择日期"
              @click="showPickDatePicker = true"
              ref="pickDate"
              clearable
            />
            <van-popup v-model="showPickDatePicker" position="bottom" round :safe-area-inset-bottom="true">
              <van-datetime-picker
                type="datetime"
                title="选择年月日"
                @confirm="onConfirmPickDate"
                @cancel="showPickDatePicker = false"
                :min-date="new Date(new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000))"
              />
            </van-popup>
          </van-panel>
        </van-cell-group>
      </div>
    </van-form>
    <van-notice-bar
      wrapable
      :scrollable="false"
      text="温馨提示：车辆年检要满足3个条件，无违章、交强险保单原件、行驶证原件（请预先准备好资料）"
      color="#b3b3b3"
      background="white"
    />
    <van-row class="agree">
      <van-col span="8">
      <van-checkbox v-model="checked" shape="square" checked-color="var(--greenColor)" icon-size="11px" class="checkedClass">
        我已阅读并同意
      </van-checkbox>
      </van-col>
      <van-col span="16">
      <a href="javascript:0;" style="font-size: 10px;">《机动车年检服务代办协议》</a><a href="javascript:0;" style="font-size: 10px;">《套餐说明》</a>
      </van-col>
    </van-row>
    <van-button native-type="button" @click="cancelOrderHandle">撤销订单</van-button>
    <van-button native-type="button" @click="showOrderHandle">查看订单</van-button>
    <!-- <div> -->
        <!-- <van-cell is-link :to="{ path: '/help' }">
          <div slot="title">
            <i class="iconfont icon088help02"></i>
            <span>帮助反馈</span>
          </div>
        </van-cell> -->
        <!-- <van-cell>
          <div slot="title">
            <i class="iconfont iconhtmal5icon31"></i>
            <span>客服电话</span>
          </div>
          <a class="tel" :href="'tel:' + '4001161638'">400-116-1638</a>
        </van-cell>
        <van-cell>
          <div slot="title">
            <i class="iconfont icontime"></i>
            <span>服务时间</span>
          </div>
          <span>工作日 8:30-18:00</span>
        </van-cell> -->
      <!-- </div> -->
      <!-- <div slot="footer">
        <van-row class="buttonRow">
          <van-col span="12">
            <van-button type="warning" @click="returnBeforeBtn" style="position: fixed;
      bottom: 0;
      width: 50%;
      line-height: var(--footer-height);">返回</van-button>
          </van-col>
          <van-col span="12">
            <van-button type="danger" style="position: fixed;
      bottom: 0;
      width: 50%;
      line-height: var(--footer-height);" @click="send">确认预约</van-button>
          </van-col>
        </van-row>
      </div> -->
      <!-- <van-popup v-model="couponsShow" :style="{ width: '80%', height: '80%' }" :close-on-click-overlay="false" round>
        <van-cell-group>
          <van-cell>
            <template #title>
              <span style="text-align: center;color: black;"><h3>预约线上年审</h3></span>
            </template>
          </van-cell>
          <van-cell>
            <div>付款金额: {{ sellData.sell_price }}</div>
          </van-cell>
          <van-coupon-cell
            :coupons="coupons"
            :chosen-coupon="chosenCoupon"
            @click="showList = true"
            title="权益券"
          />
          <van-cell>
          </van-cell>
        </van-cell-group>
          <div style="position: absolute;bottom: 0px;width: 100%">
            <van-button size="small" style="width: 50%" native-type="button" @click="cancelHandle">取消</van-button>
            <van-button size="small" type="danger" style="width: 50%">立即支付</van-button>
          </div>
      </van-popup> -->
      <PayWay
        ref="payway"
        :sellData="sellData"
        :tips="tips"
        :discount="discount"
        :isWechatPay="wechatpay"
        :type="2"
        :params="params"
        :isSend="isSend"
        :balance="balance"
        :couponsId="couponsId"
        :couponsName="couponsName"
        :isMember="isMember"
        :vip_discount="vip_discount"
        :discount_coupons="discount_coupons"
        :can_use_power="can_use_power"
        :coupon_list="coupon_list"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :ident="type"
        :carNo="carNo"
        :carType="carType"
        :detection="detection"
        :setMeal="setMeal"
        :mobile="mobile"
        :agreeChecked="checked"
        :appointTime="nsDate"
        :userLoc="pickAddress"
        :userTime="pickDate"
      />
      <!-- 优惠券列表 -->
      <!-- <van-popup
        v-model="showList"
        round
        position="bottom"
        style="height: 50%; padding-top: 4px;"
        :safe-area-inset-bottom="true"
      >
        <van-coupon-list
          :coupons="coupons"
          :chosen-coupon="chosenCoupon"
          :show-exchange-bar="false"
          @change="onChange"
          class="couponListClass"
        />
      </van-popup> -->
  </div>
</template>

<script>
import { wechatAuth } from "api/wechatSDK";
import { getCarList, getDecetionList } from 'api/car'
import defaultdata from "server/data/mobileRecharge.json";
import Tips from "server/data/tips.json";
import area from "server/data/address";
import PayWay from "components/PayWay";
import { calcelAnnualVerificationOrder, queryAnnualVerificationOrder } from 'api/submit'
const coupon = {
  available: 1,
  condition: '无使用门槛\n最多优惠12元',
  reason: '',
  value: 150,
  name: '优惠券名称',
  startAt: 1489104000,
  endAt: 1514592000,
  valueDesc: '1.5',
  unitDesc: '元',
};
export default {
  props: {
    type: String,
    name: String,
    cid: Number,
    balance: Number,
    couponsId: String,
    couponsName: String,
    couponsDeduct: Number,
    isMember: Boolean,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    PayWay,
  },
  data() {
    return {
      carNo: '',
      carType: '',
      carInfoDesc: '',
      carTypeDesc: '',
      carList: [],
      carTypeList: [
        {
          val: "01",
          desc: '大型汽车'
        }, {
          val: "02",
          desc: '小型汽车'
        }, {
          val: "51",
          desc: '新能源-大型汽车'
        }, {
          val: "52",
          desc: '新能源-小型汽车'
        }
      ],
      showCarPicker: false,
      nsDate: this.formatter(new Date(new Date().valueOf() + 24 * 60 * 60 * 1000)),
      mobile: '',
      userRealName: '',
      showSetMealPicker: false,
      setMeal: '',
      setMealDesc: '',
      setMealList: [],
      showDetectionPicker: false,
      detection: '',
      detectionDesc: '',
      detectionList: [],
      checked: false,
      showDatePicker: false,
      pickAddress: '',
      pickDate: '',
      showPickDatePicker: false,
      pickShow: false,
      latitude: "",
      longitude: "",
      showArea: false,
      areaList: {},
      area: "",
      detail: "",
      couponsShow: false,
      chosenCoupon: -1,
      coupons: [coupon],
      disabledCoupons: [coupon],
      showList: false,
      // 数据列表
      selList: [],
      selItem: null,
      canSel: false, // 整个列表是否可选
      selListDefaultData: [],
      // 支付数据
      sellData: { sell_price: -1 },
      tips: "",
      describe: "",
      discount: 0,
      index: 0,
      wechatpay: false,
      params: { account: "" },
      sms: "",
      isSend: true,
      data: {},
      vip_discount: 0,
      discount_coupons: [],
      can_use_power: false,
      coupon_list: [],
      ident:"",
    }
  },
  created() {
    getCarList().then((res) => {
      if (res.status == 200) {
        if (res.data.length != 0) {
          this.carList = res.data
          this.carNo = this.carList[0].carNo
          this.carType = this.carList[0].carType
          console.log(this.carNo)
          this.carTypeList.forEach(item => {
            if (item.val == this.carList[0].carType) {
              this.carTypeDesc = item.desc
              return
            }
          })
          this.carInfoDesc = this.carList[0].carNo + "【" + this.carTypeDesc + "】"
          wechatAuth(["getLocation", "openLocation"], this.getDecetionList);
        } else {
          this.$alert('请添加车辆').then(() => {
            this.$push({
              path: '/addCar'
            })
          })
        }
      } else {
        this.$error(res.message)
      }
    }),
    this.selListDefaultData = defaultdata;
    this.params.account = this.$getItem("userModel").userPhone;
    if(this.params.account!=""){
      this.params.account =
          this.params.account.substr(0, 3) +
          " " +
          this.params.account.substr(3, 4) +
          " " +
          this.params.account.substr(7);
    }
    this.tips = Tips.mobileBillRecharge;
  },
  mounted() {
    // this.getUserInfo();
  },
  methods: {
    getDecetionList() {
      let that = this
      wx.getLocation({
        type: "gcj02", // 默认为wgs84的 gps 坐标，如果要返回直接给 openLocation 用的火星坐标，可传入'gcj02'
        success: function (res) {
          that.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          that.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          getDecetionList(that.carList[0].carType, that.longitude, that.latitude).then((res) => {
            if (res.status == 200) {
              that.detectionList = res.data;
            } else {
              that.$error("获取检测站失败，请稍后再试");
            }
          });
        },
      })
    },
    validatorMobile(val) {
      return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(val)
    },
    formatter(time) {
      let nowdate =time == null ?  new Date() : new Date(time);
      let year = nowdate.getFullYear();
      let month = nowdate.getMonth() + 1;
      let date = nowdate.getDate();
      let nowtime = year + "-";
      if (month < 10) {
        nowtime += "0";
      }
      nowtime += month + "-";
      if (date < 10) {
        nowtime += "0";
      }
      nowtime += date;

      return nowtime;
    },
    formatterTime(time) {
      let date =time == null ?  new Date() : new Date(time);
      let Y = date.getFullYear() + '-';
	    let M = date.getMonth()+1 < 10 ? '0' + (date.getMonth() + 1)  + '-' : date.getMonth() +1 + '-' ;
	    let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
	    let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
	    let m = date.getMinutes() <10 ? '0' + date.getMinutes() + ':' :date.getMinutes() + ':';
	    let s = date.getSeconds() <10 ? '0' + date.getSeconds() : date.getSeconds();

      return  Y + M + D + h + m + s;
    },
    setMealPickerClick() {
      if (this.detection === '') {
        this.$dialog.alert({
          title: '警告！',
          message: '请先选择检测站'
        }).then(() => {
          // on close
        })
      } else {
        this.showSetMealPicker = true
      }
    },
    onConfirmCar(value) {
      this.carTypeList.forEach(item => {
        if (item.val == value.carType) {
          this.carTypeDesc = item.desc
        }
      })
      this.carInfoDesc = value.carNo+"【" + this.carTypeDesc +"】"
      this.carNo = value.carNo
      this.carType = value.carType
      this.showCarPicker = false
    },
    onConfirmDetection(value) {
      this.detectionDesc = value.name + "（" + value.nearby + "km）"
      this.detection = value.identify
      var arr = []
      if (value.quotes.selfDiverPrice) {
        arr.push({'desc': '自驾报价', 'price': value.quotes.selfDiverPrice, 'val': 'self_diver_price'})
      }
      if (value.quotes.thirdDiverPrice) {
        arr.push({'desc': '包车接送报价', 'price': value.quotes.thirdDiverPrice, 'val': 'third_diver_price'})
      }
      if (value.quotes.vipPrice) {
        arr.push({'desc': '修复包过报价', 'price': value.quotes.vipPrice, 'val': 'vip_price'})
      }
      if (value.quotes.otherPrice) {
        arr.push({'desc': '其他', 'price': value.quotes.otherPrice, 'val': 'other_price'})
      }
      this.setMealList = arr
      this.showDetectionPicker = false
    },
    onConfirmsetMeal(value) {
      this.setMeal = value.val
      this.setMealDesc = value.desc + "（" + value.price + "元）"
      this.sellData = {
        sell_price: Number(value.price),
      };
      this.params.productNo = 1227
      if (this.setMealDesc.indexOf('包') != -1 || this.setMealDesc.indexOf('其他') != -1) {
        this.areaList = area;
        this.pickDate = this.formatterTime(new Date(new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000)))
        this.pickShow = true
      } else {
        this.areaList = {}
        this.pickDate = ''
        this.pickShow = false
      }
      this.showSetMealPicker = false
    },
    onConfirmDate(value) {
      this.nsDate = this.formatter(value)
      this.showDatePicker = false
    },
    onConfirmPickDate(value) {
      this.pickDate = this.formatterTime(value)
      this.showPickDatePicker = false
    },
    returnBeforeBtn() {
      history.back()
    },
    detailBlur() {
      this.pickAddress = this.area.replace(/[/]/g, "") + this.detail
    },
    send() {
      this.$refs.onlineNsForm.submit();
    },
    onSave(values) {
      console.log(this.area.replace(/[/]/g, "") + this.detail)
      if (this.checked === false) {
        this.$error('请先阅读并勾选《机动车年检代办协议》')
        return
      }
      this.couponsShow = true
      return
      var formData = {
        carNo: this.carNo,
        detection: this.detection,
        setMeal: this.setMeal,
        mobile: this.mobile,
        userRealName: this.userRealName,
        nsDate: this.nsDate,
        pickAddress: this.pickAddress,
        pickDate: this.pickDate
      }
      console.log(formData)
      alert('提交')
    },
    onConfirmArea(values) {
      this.area = values.map((item) => item.name).join("/");
      this.showArea = false;
    },
    openCoupons() {
      // this.link = 'mobileBillRecharge'
      this.couponsShow = true
    },
    onChange(index) {
      this.showList = false;
      this.chosenCoupon = index;
    },
    cancelHandle() {
      this.couponsShow = false
    },
    cancelOrderHandle() {
      this.$confirm("取消后不可恢复，确认要取消订单吗？", "确认提示", "#EE0A24")
        .then(() => {
          this.$loading("取消中");
          var orderNo = 'LM16774623772277992111'
          calcelAnnualVerificationOrder(orderNo).then((res) => {
            this.$clear();
            if (res.status === 200) {
              this.$successSync("订单取消成功", () => {
                // this.$parent.$parent.$parent.$parent.$parent.currentPages = 1;
                // this.$parent.$parent.$parent.$parent.$parent.len = 0;
                // this.$parent.$parent.$parent.$parent.$parent.finished = false;
                // this.$parent.$parent.$parent.$parent.$parent.loading = true;
                // this.$parent.$parent.$parent.$parent.$parent.onLoad();
              });
            } else {
              this.$error(res.message);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    showOrderHandle() {
      var orderNo = 'LM16774623772277992111'
      queryAnnualVerificationOrder(orderNo).then((res) => {
        if (res.status === 200) {
          alert("获取订单成功")
        } else {
          this.$error(res.message)
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.onlineNs{
  .agree{
    background-color: white;
  }
  .discount_coupons {
    background: inherit;
    color: #fff;
    .van-cell {
      padding: inherit;
      align-items: center;
      margin-bottom: 15px;
      box-shadow: #ccc 0 0 5px;
      background: red;
      color: #fff;
      border-radius: 10px;
      .van-cell__title {
        flex: inherit;
        border-right: 2px solid #cccccc82;
        padding: 10px;
      }
      .van-cell__value {
        // padding: 0px 10px;
        margin: 10px 0px 10px 10px;
        text-align: left;
        color: #fff;
      }
      .van-radio {
        margin-right: 10px;
        color: #fff;
        border-color: #fff;
        border-width: 2px;
      }
      /deep/ .van-icon {
        border: 2px solid #f7f8fa;
      }
      /deep/ .van-radio__icon--checked {
        .van-icon {
          background-color: inherit;
          border-color: inherit;
        }
      }
      .left_money {
        font-size: 30px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 5px;
      }
      .left_time {
        background: #fff;
        color: red;
        border-radius: 10px;
        display: flex;
        align-items: center;
        /* justify-content: center; */
        height: 20px;
        font-size: 12px;
        span {
          padding: 0px 5px;
        }
      }
      .right_name {
        font-size: 16px;
        font-weight: bold;
      }
      .right_time {
        font-size: 14px;
      }
    }
  }
}
a {
  color: #000099;
  font-size: 15px;
  line-height: 19px;
}
/deep/ .van-checkbox__label{
  font-size: 10px;
}
/deep/ .van-checkbox__icon {
  padding-left: 16px;
  padding-bottom: 2px;
}
// /deep/ .van-cell__title {
//   color: #b3b3b3;
// }
/deep/ .van-field__label {
  color: #646566;
}
/deep/ .checkedClass .van-icon {
  border-radius: 2px;
}
/deep/ .van-coupon-list__list--with-bottom{
  height: 352px;
}
</style>
